const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const _ = require("lodash");
const URLMake = require("../../shared/URLMake");
const BookstoreUtil = require("../../shared/BookstoreUtil");
const AssetsUtil = require("../core/util/AssetsUtil");
const withAnimateScroll = require("../core/hoc/withAnimateScroll");
const {getBaseInstance} = require("../core/util/HOCUtil");
const TabView = require("./TabView");
const SwitchView = require("./SwitchView");
const OpenBook = require("./OpenBook");
const CarouselView = require("./CarouselView");
const Expandable = require("./Expandable");
const Link = require("../core/view/Link");
const Printables = require("./data/printables.json");
const PlacementTests = require("./data/placementtests.json");
const Plannings = require("./data/plannings.json");
const Errata = require("./data/Errata");

const styles = require("./styles/PageResources.css");
const Copy = require("./data/CopyTable").getResourcesCopy(styles);
const beyondBACopy = require("./data/CopyTable").getBeyondBACopy(styles);
const SupportCopy = require("./data/SupportPlanningCopy").getPlanningText(
	styles
);

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withAnimateScroll(Component);
	return Component;
};

module.exports = augment(
	createReactClass({
		displayName: "PageResources",

		propTypes: {
			section: PT.oneOf([
				"printables",
				"placementtests",
				"planning",
				"errata",
				"backgrounds",
			]),
			planningCategoryHash: PT.string,
			setNextScrollTo: PT.func.isRequired,

			// Injected by HOCs
			animateScroll: PT.func.isRequired,
		},

		getDefaultProps: function() {
			return {section: "printables"};
		},

		getInitialState: function() {
			this.linkedPlanningContainer = null;
			return {};
		},

		componentDidMount: function() {
			if (this.props.planningCategoryHash && this.linkedPlanningContainer) {
				this.props.setNextScrollTo(this.linkedPlanningContainer);
			}
		},

		componentDidUpdate: function(prevProps, prevState) {
			if (this.props.planningCategoryHash !== prevProps.planningCategoryHash) {
				//Animate scroll to the new question
				this.props.animateScroll({
					scrollThing: this.linkedPlanningContainer,
					timeRatio: 0.65,
					maxTime: 1000,
				});
			}
		},

		makeHashCircle: function(hash, isOnlyGrade) {
			const isPuzzleBook = BookstoreUtil.isPuzzleBook(hash);
			const gNum = isPuzzleBook ? hash.substring(7) : parseInt(hash);
			let className = styles["grade" + gNum];
			if (isOnlyGrade) {
				className += " " + styles.gradeCircle;
			}
			const contents = isPuzzleBook ? (
				<img
					src={AssetsUtil.getPuzzlePiece("white")}
					className={styles.puzzlePieceIcon}
					alt={`Puzzles ${gNum}`}
				/>
			) : (
				hash
			);
			return <span className={className}>{contents}</span>;
		},

		beyondBAContent: function(gradeNumber) {
			return !gradeNumber || parseInt(gradeNumber) === 5 ? (
				<div className={styles.expandableTextContainer}>
					{beyondBACopy.resources}
				</div>
			) : null;
		},

		wrapRenderWithIntro: function(node, copyKey, character) {
			const content =
				character !== "alex" ? (
					<div className={styles.main}>
						<div className={styles.pageWrap}>{node}</div>
					</div>
				) : (
					node
				);

			return (
				<div className={styles[`${character}Main`]}>
					<div className={styles.introOuter}>
						<div className={styles[character]}>
							<div className={styles[`${character}PaddingContainer`]}>
								<img
									className={styles[`${character}Img`]}
									alt=""
									src={AssetsUtil.getOfficeCharacter(
										Copy.characters[character].img
									)}
								/>
							</div>
						</div>
						<div className={styles[`${character}Intro`]}>{Copy[copyKey]}</div>
					</div>
					{content}
				</div>
			);
		},

		renderPrintables: function() {
			const byBook = BookstoreUtil.getAvailableBooks({
				excludeBooks: ["puzzles1", "puzzles2", "puzzles4"],
			}).map(hash => {
				let topics;
				if (hash === "puzzles3") {
					topics = "Connect the Critters and Arranging Squares";
				} else {
					topics = BookstoreUtil.getBookTopicsString(hash);
				}
				const title = (
					<div className={styles.bookTitle}>
						<div className={styles.titleCircle}>
							{this.makeHashCircle(hash)}
						</div>
						<div className={styles.topics}>{topics}</div>
					</div>
				);
				return (
					<Expandable
						key={"printables" + hash}
						ignoreHorizontalPadding={true}
						title={title}
					>
						<div>
							<div className={styles.printables}>
								{this.getBookPrintables(hash, false)}
							</div>
							<div className={styles.printablesWide}>
								{this.getBookPrintables(hash, true)}
							</div>
						</div>
					</Expandable>
				);
			});

			byBook.push(
				<Expandable
					key={"printables-general"}
					ignoreHorizontalPadding={true}
					title={
						<div className={styles.bookTitle}>
							General: Graph Paper and Rulers
						</div>
					}
				>
					<div>
						<div className={styles.printables}>
							{this.getBookPrintables("general", false)}
						</div>
						<div className={styles.printablesWide}>
							{this.getBookPrintables("general", true)}
						</div>
					</div>
				</Expandable>
			);

			return this.wrapRenderWithIntro(byBook, "printables", "headmaster");
		},

		renderVirtualBackgrounds: function() {
			const backgrounds = [
				{
					name: "campus",
					title: "BEAST ACADEMY CAMPUS",
					imgSrc: "background-academy",
				},
				{
					name: "classroom",
					title: "BEAST ACADEMY CLASSROOM",
					imgSrc: "background-classroom",
				},
			];

			const contents = _.map(backgrounds, background => {
				const title = (
					<div className={styles.bookTitle}>{background.title}</div>
				);
				const imagePath = AssetsUtil.getOfficeElement(background.imgSrc, "png");

				return (
					<Expandable
						key={"virtualbackground" + background.name}
						startExpanded={true}
						title={title}
					>
						<div className={styles.virtualBackgroundContainer}>
							<a
								className={styles.backgroundImageLink}
								download={background.imgSrc + ".png"}
								href={imagePath}
							>
								<img
									src={imagePath}
									className={styles.backgroundImage}
									alt={background.title}
								/>
							</a>
							<div className={styles.downloadButtonContainer}>
								<a download={background.imgSrc + ".png"} href={imagePath}>
									<img
										src={AssetsUtil.getOfficeElement("download-button")}
										className={styles.downloadButtonImage}
										alt={"Download button"}
									/>
								</a>
							</div>
						</div>
					</Expandable>
				);
			});

			return this.wrapRenderWithIntro(contents, "backgrounds", "headmaster");
		},

		renderPlacementTests: function() {
			const byGrade = BookstoreUtil.getAvailableGrades().map(grade => {
				const gradePlacementTests = BookstoreUtil.getAvailableBooksInGrade(
					grade,
					{excludeTypes: ["puzzle", "science"]}
				).map(bookHash => {
					const pageData = _.extend({}, PlacementTests[bookHash], {bookHash});
					return (
						<div key={"outer" + bookHash}>
							{this.makeSinglePlacementTest(pageData, true)}
						</div>
					);
				});
				const elWide = (
					<div className={styles.asSet}>{gradePlacementTests}</div>
				);
				const el = this.getGradePlacementTests(grade);
				const title = (
					<div className={styles.bookTitle}>
						{"Are you ready for Beast Academy "}
						{this.makeHashCircle(grade, true)}
						{" ?"}
					</div>
				);

				return (
					<Expandable
						key={"grade" + grade}
						ignoreHorizontalPadding={true}
						startExpanded={true}
						title={title}
					>
						<div>
							<div className={styles.placementTests}>{el}</div>
							<div className={styles.placementTestsWide}>{elWide}</div>
							{this.beyondBAContent(grade)}
						</div>
					</Expandable>
				);
			});

			return this.wrapRenderWithIntro(byGrade, "placementtests", "headmaster");
		},

		renderPlanning: function() {
			const categories = BookstoreUtil.getPlanningDescriptors();
			const categoryTitleMapping = {
				overviews: "chapter overviews",
			};
			const title = c => (
				<div className={styles.bookTitle + " " + styles.allCaps}>
					{_.get(categoryTitleMapping, c, c)}
				</div>
			);

			const byCategory = categories.map(cat => {
				const category = _.toLower(cat);
				const isLinkedPlanning = category === this.props.planningCategoryHash;
				const usingLinkedPlanning = this.props.planningCategoryHash;
				let refFunction = null;
				if (isLinkedPlanning) {
					refFunction = l => {
						this.linkedPlanningContainer = l && getBaseInstance(l).getRef();
					};
				}

				return (
					<Expandable
						key={category}
						ref={refFunction}
						ignoreHorizontalPadding={true}
						startExpanded={!usingLinkedPlanning || isLinkedPlanning}
						title={title(category)}
					>
						<div>
							<div className={styles.plannings}>
								{this.getCategoryPlanning(category, false)}
							</div>
							<div className={styles.planningsWide}>
								<div className={styles.expandableTextContainer}>
									<div className={styles.expandablePlanningText}>
										{SupportCopy[category.toLowerCase()]}
									</div>
								</div>
								{this.getCategoryPlanning(category, true)}
							</div>
							{category === "sequence" ? this.beyondBAContent() : null}
						</div>
					</Expandable>
				);
			});

			return this.wrapRenderWithIntro(byCategory, "planning", "headmaster");
		},

		getErrataForType: function(bookHash, errataData, typeName = "") {
			if (!errataData) {
				return null;
			}
			const noTitle =
				BookstoreUtil.isScienceBook(bookHash) ||
				BookstoreUtil.isPuzzleBook(bookHash) ||
				BookstoreUtil.isComboBook(bookHash);

			const errataList = errataData.map((data, i) => {
				const page = _.isString(data.page) ? "pages" : "page";
				const errClass =
					(noTitle ? styles.errItem : styles.errItemNoTitle) +
					(data.corrected ? " " + styles.corrected : "");
				return (
					<p key={bookHash + typeName + i} className={errClass}>
						{"On " + page + " " + data.page + ", "}
						{data.content}
					</p>
				);
			});
			const title = noTitle ? null : (
				<p className={styles.typeTitle}>{typeName}</p>
			);

			return (
				<div className={styles.bookType}>
					{title}
					{errataList}
				</div>
			);
		},

		renderErrata: function() {
			//Errata list by book
			const errataList = BookstoreUtil.getAvailableBooks().map(bookHash => {
				const data = Errata[bookHash] || {};
				const practiceEl = this.getErrataForType(
					bookHash,
					data.practice,
					"Practice"
				);
				const guideEl = this.getErrataForType(bookHash, data.guide, "Guide");
				const puzzleEl = this.getErrataForType(bookHash, data.puzzle);
				const scienceEl = this.getErrataForType(bookHash, data.science);
				const comboEl = this.getErrataForType(
					bookHash,
					data.combinedBookPracticeBook
				);
				let comment = null;
				if (!practiceEl && !guideEl && !puzzleEl && !scienceEl && !comboEl) {
					comment = (
						<div className={styles.errItem}>
							<p>{Errata.noError}</p>
						</div>
					);
				}

				let title;
				if (BookstoreUtil.isPuzzleBook(bookHash)) {
					const grade = BookstoreUtil.getGradeFromHash(bookHash);
					const circleClass = styles["grade" + grade];
					title = (
						<div className={styles.errataTitle}>
							{`BA Puzzles `}
							<span className={circleClass}>{grade}</span>
						</div>
					);
				} else if (BookstoreUtil.isScienceBook(bookHash)) {
					title = (
						<div className={styles.errataTitle}>
							Beast Academy Science{" "}
							{this.makeHashCircle(bookHash.substring(0, bookHash.length - 1))}
						</div>
					);
				} else {
					title = (
						<div className={styles.errataTitle}>
							Beast Academy {this.makeHashCircle(bookHash)}
						</div>
					);
				}

				return (
					<Expandable
						key={"errata" + bookHash}
						className={styles.errataGrade}
						title={title}
					>
						<div>
							{comment}
							{guideEl}
							{practiceEl}
							{puzzleEl}
							{scienceEl}
							{comboEl}
						</div>
					</Expandable>
				);
			});

			return this.wrapRenderWithIntro(errataList, "errata", "alex");
		},

		getBookPrintables: function(bookHash, isWide) {
			const contents = Printables[bookHash].map((data, i) => {
				return this.makeSinglePrintable(data, bookHash, i);
			});
			if (isWide) {
				return contents;
			} else {
				return (
					<CarouselView
						className={styles.carousel}
						contentEls={contents}
						key={"carousel" + bookHash}
						arrowTop={"30%"}
						arrowColor={"blue"}
						isFullWidth={false}
					/>
				);
			}
		},

		makeSinglePrintable: function(data, hash, i, isWide) {
			const pageData = _.extend({}, data);
			let subtitle = "";
			if (pageData.subtitle) {
				subtitle = pageData.subtitle;
			} else if (pageData.bookType) {
				subtitle += _.capitalize(pageData.bookType) + " ";
				subtitle += BookstoreUtil.getPageString(pageData);
			}
			let chapter = null;
			if (pageData.chapter) {
				chapter = (
					<img
						src={AssetsUtil.getImageForChapterInGrade(pageData.chapter, "blue")}
						className={styles.chapter}
					/>
				);
			}
			pageData.subtitle = subtitle || "";
			pageData.bookHash = hash;
			const extraClass =
				hash === "general"
					? styles.printableNoChapter
					: styles.printableWithChapter;
			if (hash === "general" && pageData.book) {
				pageData.bookHash = pageData.book;
			}
			const imgAlt = pageData.title + ": " + subtitle + " Thumbnail";
			return (
				<div
					className={styles.page}
					key={hash + "printable" + i}
					ref={hash + (i ? i : "") + (isWide ? "wide" : "")}
				>
					<OpenBook
						alt={imgAlt || ""}
						pageData={pageData}
						type={"printable"}
						isDescriptionLink={true}
						smallDescriptions={true}
						colorScheme={"blue"}
						className={extraClass}
					/>
					{chapter}
				</div>
			);
		},

		getGradePlacementTests: function(grade) {
			const availableBooks = BookstoreUtil.getAvailableBooksInGrade(grade, {
				excludeTypes: ["puzzle", "science"],
			});

			const contents = availableBooks.map(bookHash => {
				const pageData = _.extend({}, PlacementTests[bookHash], {bookHash});
				return this.makeSinglePlacementTest(pageData);
			});
			return (
				<SwitchView
					className={styles.switch}
					views={contents}
					widthClass={styles.switchDim}
					colorScheme={"grade-" + grade}
					buttonTitles={BookstoreUtil.getGradeHashSequence(grade, {
						excludeTypes: ["puzzle", "science"],
					})}
					showButtons={true}
					buttonsOnBottom={true}
					preventTitleCollapse={true}
				/>
			);
		},

		makeSinglePlacementTest: function(pageData, showSub) {
			const bookHash = pageData.bookHash;
			const imgAlt = "Placement test for " + bookHash + " Thumbnail";
			let sub = null;
			if (showSub) {
				sub = <div className={styles.sub}>{this.makeHashCircle(bookHash)}</div>;
			}
			return (
				<Link
					className={styles.aPage}
					key={bookHash + "placementtest"}
					to={global.PDF_URL + bookHash + "/" + pageData.link}
					isNewTab={true}
				>
					<OpenBook
						alt={imgAlt || ""}
						pageData={pageData}
						type={"placementtest"}
						hasHoverEffect={true}
					/>
					{sub}
				</Link>
			);
		},

		getCategoryPlanning: function(category, isWide) {
			const grades = BookstoreUtil.getAvailableGrades();

			const contents = grades.map(grade => {
				const pageData = _.extend(
					{planningHash: category, grade},
					_.get(Plannings, `${_.toLower(category)}.${grade}`, {})
				);
				return this.makeSinglePlanning(pageData, grade);
			});
			if (isWide) {
				return contents;
			} else {
				return (
					<CarouselView
						className={styles.carousel}
						contentEls={contents}
						key={"carouselplanning" + category}
						arrowTop={"30%"}
						arrowColor={"blue"}
						isFullWidth={false}
					/>
				);
			}
		},

		makeSinglePlanning: function(pageData, grade, isWide) {
			const hash = `planning-${pageData.planningHash}-${grade}`;
			const title = pageData.planningHash;
			const gradePlanning = (
				<img
					src={AssetsUtil.getImageForGrade(grade, "blue")}
					className={styles.chapter}
				/>
			);
			pageData.bookHash = _.toLower(title);
			const extraClass = styles.printableWithChapter;
			return (
				<div className={styles.page} key={hash} ref={hash}>
					<OpenBook
						pageData={pageData}
						type={"planning"}
						isDescriptionLink={true}
						colorScheme={"blue"}
						className={extraClass}
						hasHoverEffect={true}
					/>
					{gradePlanning}
				</div>
			);
		},

		render: function() {
			const {section} = this.props;

			if (section === "errata") {
				return (
					<div className={styles.errataContainer}>
						<div className={styles.errataPageTitle}>ERRATA</div>
						{this.renderErrata()}
					</div>
				);
			}

			const selectedTab = Math.max(
				["planning", "placementtests", "printables", "backgrounds"].indexOf(
					section
				),
				0
			);

			const flexibleTabText = (prefix, suffix, hyphen = true) => {
				return (
					<span className={styles.textAlign}>
						{prefix}
						{hyphen ? <span className={styles.hyphen}>-</span> : " "}
						<br className={styles.hyphen} />
						{suffix}
					</span>
				);
			};

			return (
				<TabView
					title={"Resources"}
					largeTitle={false}
					tabTitles={[
						flexibleTabText("Plan", "ning"),
						flexibleTabText("Placement", "Tests", false),
						flexibleTabText("Print", "ables"),
						flexibleTabText("Back", "grounds"),
					]}
					tabs={[
						this.renderPlanning(),
						this.renderPlacementTests(),
						this.renderPrintables(),
						this.renderVirtualBackgrounds(),
					]}
					tabLinks={[
						URLMake.forResources("planning"),
						URLMake.forResources("placementtests"),
						URLMake.forResources("printables"),
						URLMake.forResources("backgrounds"),
					]}
					selectedTab={selectedTab}
				/>
			);
		},
	})
);
